import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface WindowsAndDoorsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const WindowsAndDoors: React.FC<WindowsAndDoorsProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [windowsAndDoors, set_windowsAndDoors] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Windows and Doors']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Windows and Doors': [b.values?.['Exterior Structure']?.['Windows and Doors']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Windows and Doors';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(windowsAndDoors)}
                />
            ) : (
                <MoneyBox
                    id={'windowsAndDoors'}
                    allowNegative={false}
                    value={windowsAndDoors}
                    onChange={(value) => set_windowsAndDoors(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
